/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Email_LabelInputs */

const es_privacy_policy_contact_email_label = /** @type {(inputs: Privacy_Policy_Contact_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de Privacidad`)
};

const en_privacy_policy_contact_email_label = /** @type {(inputs: Privacy_Policy_Contact_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Email`)
};

/**
* | output |
* | --- |
* | "Privacy Email" |
*
* @param {Privacy_Policy_Contact_Email_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_email_label = /** @type {((inputs?: Privacy_Policy_Contact_Email_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Email_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_email_label(inputs)
	return en_privacy_policy_contact_email_label(inputs)
});
export { privacy_policy_contact_email_label as "privacy_policy.contact.email_label" }